import type { DocumentNode } from 'graphql'
import { print } from 'graphql'

type Variables = {
  [key: string]: any
}

type Response<T> = {
  data: T
  extensions?: any
  status: number
}

const HOST = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID!
const DATASET = process.env.NEXT_PUBLIC_SANITY_DATASET!
const ENDPOINT = `https://${HOST}.api.sanity.io/v1/graphql/${DATASET}/default`

export async function request<T, V extends Variables>(
  query: DocumentNode,
  variables?: V,
  config?: NextFetchRequestConfig,
): Promise<Response<T>> {
  const response = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.SANITY_TOKEN!}`,
    },
    body: JSON.stringify({ query: print(query), variables }),
    next: config,
  })
  return response.json() as unknown as Response<T>
}
